import React from "react";
import { Link } from "react-router-dom";
import FaqData1 from "./FaqData1";
import FaqData2 from "./FaqData2";

const Faq = () => {
  return (
    <>
      <section className="faq-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Frequently Asked Questions</h3>
                <p>
                  Here are some information about ISP Digital asked by our
                  clients.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <FaqData1 />
            <FaqData2 />
          </div>
          <div className="row">
            <div className="col-12">
              <div className="faq-btn">
                <Link to="#" className="theme-btn">
                  Read all FAQ
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
